<template lang="pug">
  .container.grid-lg
    load-manager(:status="status")
      div(v-if='list.length > 0')
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th {{ 'pontuacao_resumo.referencia' | tModel }}
              th {{ 'pontuacao_resumo.usuario' | tModel }}
              th {{ 'pontuacao_resumo.individual_liquido' | tModel }}
              th {{ 'pontuacao_resumo.extraordinario' | tModel }}
              th {{ 'pontuacao_resumo.coletivo' | tModel }}
              th {{ 'pontuacao_resumo.total' | tModel }}
              th
          tbody
            router-link.c-hand(
              tag='tr' 
              v-for="row in list" 
              :key='row.id' 
              :to="{name: 'app.produtividade.resumos.show', params: { resumoId: row.id } }"
            )
              td {{ row.referencia }}
              td {{ row.usuario.nome }}
              td {{ row.individual_liquido }}
              td {{ row.extraordinario }}
              td {{ row.coletivo }}
              td {{ row.total }}
              td
                i.fa.fa-chevron-right
      .empty.mt-2(v-else)
        .empty-icon
          i.icon.icon-search
        p.empty-title.h5 Nenhum Registro encontrado

    .my-2.text-right(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'

export default {
  vuex: { 'produtividade/resumos': vuexDefaultMapping },

  data() {
    return { q: {} }
  },

  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },

  created() {
    this.q = { ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
